import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import NotFound from "@/pages/NotFound";
import AuthCallback from "@/components/AuthCallback";
import { AuthProvider } from "@/context/AuthContext";
import { LangProvider } from "@/context/LangContext";
import { ThemeProvider } from "@/context/ThemeContext";

const LEGACY_RE = /(youtube|youtu\.be|facebook|fb\.watch|twitter|x-video|download-x|tiktok-video-downloader)/i;
const LEGACY_LANG_RE = /^\/(es|fr|de|it|pt|tr|ru|id|hi|ur|zh|ja|ko|vi|nl|pl|th)(\/|$)/i;

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  const p = location.pathname.replace(/\/+$/, "") || "/";
  if (p === "/ar") {
    return <Navigate to="/" replace />;
  }
  if (p.startsWith("/ar/")) {
    return <Navigate to={p.slice(3)} replace />;
  }
  if (LEGACY_RE.test(p) || LEGACY_LANG_RE.test(p)) {
    return <Navigate to="/" replace />;
  }
  const isHome = p === "/" || p === "/en";
  return (
    <Routes>
      <Route path="*" element={isHome ? <Home /> : <NotFound />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App noise-overlay">
      <ThemeProvider>
        <LangProvider>
          <AuthProvider>
            <BrowserRouter>
              <AppRouter />
            </BrowserRouter>
          </AuthProvider>
        </LangProvider>
      </ThemeProvider>
      <Toaster position="top-center" theme="dark" richColors />
    </div>
  );
}

export default App;
